import { getData, postData } from "@/request/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

/* ids of the user's favorited properties (lightweight, for hearts) */
export const useFavoriteIds = (enabled = true) => {
  return useQuery({
    queryKey: ["favorite-ids"],
    enabled,
    queryFn: async () => {
      const res = await getData("favorites/ids");
      return (res.data?.ids ?? []) as string[];
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};

/* full favorited properties (favorites page) */
export const useFavorites = ({ page = 1 } = {}) => {
  return useQuery({
    queryKey: ["favorites", page],
    queryFn: async () => {
      const res = await getData(`favorites?page=${page}`);
      return res.data;
    },
    staleTime: 60 * 1000,
  });
};

export const useToggleFavorite = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (propertyId: string) => {
      const res = await postData("favorites/toggle", { propertyId });
      return res.data as { favorited: boolean };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["favorite-ids"] });
      qc.invalidateQueries({ queryKey: ["favorites"] });
    },
  });
};
